import React, { useState } from "react";
import axios from "axios";


const useStep = ({
    onStepFinish = ({ axiosMode, status, values }) => { },
    onStepBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getStepData = (params) => {
        onStepBefore({
            axiosMode: "get"
        })
        return axios.get('/pmis/ai_flow_automation/step', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onStepFinish({
                        axiosMode: "get",
                        status: "success",
                        values: data?.data
                    })
                }
                else {
                    onStepFinish({
                        axiosMode: "get",
                        status: "failure"
                    })
                }
                return {
                    ...data
                }
            });
    }
    const postStepData = (data) => {
        onStepBefore({
            axiosMode: "post"
        })
        axios.post('/pmis/ai_flow_automation/step',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onStepFinish({
                        axiosMode: "post",
                        status: "failure"
                    })
                } else {
                    onStepFinish({
                        axiosMode: "post",
                        status: "success",
                        values: responseData
                    })
                }
            })
            .catch(() => {
                onStepFinish({
                    axiosMode: "post",
                    status: "failure"
                })
            })

    }
    const patchStepData = (data) => {
        onStepBefore({
            axiosMode: "patch"
        })
        axios.patch('/pmis/ai_flow_automation/step',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onStepFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onStepFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onStepFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const deleteStepData = (data) => {
        onStepBefore({
            axiosMode: "delete"
        })
        axios.delete('/pmis/ai_flow_automation/step',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onStepFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onStepFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onStepFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }
    return {
        StepData: data,
        getStepData,
        postStepData,
        patchStepData,
        deleteStepData,
    }
}
export { useStep }
